import { render, staticRenderFns } from "./selectionInfo.vue?vue&type=template&id=144a324f"
import script from "./selectionInfo.vue?vue&type=script&lang=js"
export * from "./selectionInfo.vue?vue&type=script&lang=js"
import style0 from "./selectionInfo.vue?vue&type=style&index=0&id=144a324f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports